export default __webpack_public_path__ + "static/media/versus-erp.21880a4c.png";